import { render } from "./SidebarLogo.vue?vue&type=template&id=1bc4096c"
import script from "./SidebarLogo.vue?vue&type=script&lang=js"
export * from "./SidebarLogo.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__